// import customerTbl from "./slice/customerTbl";
// import firmlist from "./slice/firmlist";
// import getItemName from "./slice/getItemName";
// import saleorderno from "./slice/saleorderno";
// import statedrop from "./slice/statedrop";

import { configureStore } from "@reduxjs/toolkit";
// import venderrawtbl from "./slice/venderrawtbl";
// import reducerPagination from "./reducers/paginationReducers";
// import employeeTbl from "./slice/employeeTbl";
// import fabricClothTbl from "./slice/fabricClothTbl";
// import ItemMasterReg from "./slice/ItemMasterReg";
// import removeItemJobRate from "./slice/removeItemJobRate";
// import rackRegister from "./slice/rackRegister";
// import materialInwReg from "./slice/materialInwReg";
// import materialOutReg from "./slice/materialOutReg";
// import transportReg from "./slice/transportReg";
// import upFabClothSt from "./slice/upFabClothSt";
// import firmRegTbl from "./slice/firmRegTbl";
// import saleParty from "./slice/saleParty";
// import departName from "./slice/departName";
// import fabricClothEntry from "./slice/fabricClothEntry";
// import materialName from "./slice/materialName";
// import getClothName from "./slice/getClothName";
// import cutting from "./slice/cutting";
// import Stitching from "./slice/Stitching";
// import firm, { createFirmEntry } from "./vslice/firm";
// import employee from "./vslice/employee";
// import cloth, { createClothEntry } from "./vslice/cloth";
// import item, { createItemEntry } from "./vslice/item";
// import department, { createDepartmentEntry } from "./vslice/department";
// import panna, { createPannaEntry } from "./vslice/panna";
// import itemAverage from "./vslice/itemAverage";
// import jobrate, { createJobRateEntry } from "./vslice/jobrate";
// import log from "./vslice/log";
// import rack, { createRackEntry } from "./vslice/rack";
// import purchase, { createPurchaseEntry } from "./vslice/purchase";
// import totalSlice from "./vslice/totalSlice";

import Firm, { createFirmEntry } from "./PHPSlice/Firm";
import Department, { createDepartmentEntry } from "./PHPSlice/Department";
import Panna from "./PHPSlice/Panna";
import Employee from "./PHPSlice/Employee";
import Cloth from "./PHPSlice/Cloth";
import States from "./PHPSlice/States";
import Party from "./PHPSlice/Party";
import Vendor from "./PHPSlice/Vednor";
import Salesman from "./PHPSlice/Salesman";
import Guaranteer from "./PHPSlice/Guaranteer";
import Item from "./PHPSlice/Item";
import ItemAvg, { createItemAvgEntry } from "./PHPSlice/ItemAvg";
import Rack from "./PHPSlice/Rack";
import SamplePrice from "./PHPSlice/SamplePrice";
import School from "./PHPSlice/School";
import Transport from "./PHPSlice/Transport";
import Logo from "./PHPSlice/Logo";
import Material from "./PHPSlice/Material";
import MatInward from "./PHPSlice/MatInward";
import MatOutward from "./PHPSlice/MatOutward";
import MatStock from "./PHPSlice/MatStock";
import clothStock from "./PHPSlice/clothStock";
import ReadyMadeStk from "./PHPSlice/UploadStk/ReadyMadeStk";
import PricePercent from "./PHPSlice/Sale/PricePercent";
import JobRate from "./PHPSlice/JobRate";
import PoNo from "./PHPSlice/Purchase/PoNo";
import PurchaseInward from "./PHPSlice/Inward/PurchaseInward";
import Quotation from "./PHPSlice/Sale/Quotation";
import SaleOrder from "./PHPSlice/Sale/SaleOrder";
import Category from "./PHPSlice/WorkerM/Category";
import SOMcutting from "./PHPSlice/Cutting/SOMcutting";
import clothIssue from "./PHPSlice/Cutting/clothIssue";
import cuttingApi from "./PHPSlice/Cutting/cuttingApi";
import numberingApi from "./PHPSlice/Numbering/numberingApi";
import StitchApi from "./PHPSlice/Stitching/StitchApi";
import KajeApi from "./PHPSlice/Kaje/KajeApi";
import PressingApi from "./PHPSlice/Press/PressingApi";
import StockApis from "./PHPSlice/Stock/StockApis";
import PackApis from "./PHPSlice/Packing/PackApis";
import InvoiceApi from "./PHPSlice/Invoice/InvoiceApi";
import jobworkApi from "./PHPSlice/Jobwork/jobworkApi";
import paymentApi from "./PHPSlice/Payment/paymentApi";
import TransferCloth from "./PHPSlice/UploadStk/TransferCloth";
import MultipleQuot from './PHPSlice/Sale/MultipleQuot';
import AllTracking from './PHPSlice/Tracking/AllTracking';
import fusioningApi from './PHPSlice/Fusioning/fusioningApi';
import TrimApi from './PHPSlice/Trimming/TrimApi';
import receiptApi from './PHPSlice/ReceiptApi/receiptApi';
import transportBailReducer from "./PHPSlice/Transport/transportBail";
import Printing from "./PHPSlice/Printing";
import PatternMatching from "./PHPSlice/Pattern/PatternMatching";
import retailerApi from "./PHPSlice/retailerAPi";
import TeamLeader from "./PHPSlice/TeamLeader/TeamLeader";

export const store = configureStore({
    reducer: {
        // stateName : statedrop,
        // saleOrder :saleorderno,
        // firmList : firmlist,
        // getItem : getItemName,
        // customerData: customerTbl,
        // purchaseParty: venderrawtbl,
        // pagination : reducerPagination,
        // employeeData : employeeTbl,
        // FabricClothData: fabricClothTbl,
        // ItemMasterReg : ItemMasterReg,
        // RemoveJobRate : removeItemJobRate,
        // RackRegister : rackRegister,
        // mateInwReg : materialInwReg,
        // mateOutReg :materialOutReg,
        // TransportReg : transportReg,
        // clothuploadstock :upFabClothSt,
        // firmReg : firmRegTbl,
        // partyName : saleParty,
        // DeptNm : departName,
        // FabClothEntry : fabricClothEntry,
        // materialName : materialName,
        // getCloth : getClothName,
        // CuttingEntry : cutting,
        // StitchingAll : Stitching,
        // companyData :firm,
        // EmployeeData : employee,
        // clothData : cloth,
        // itemData : item,
        // departmentData :department,
        // pannaData : panna,
        // itemAverageR: itemAverage,
        // jobRateData : jobrate,
        // auth: log,
        // rackData : rack,
        // purchaseData : purchase,
        // total: totalSlice,


        FirmData: Firm,
        DepartmentData: Department,
        PannaData: Panna,
        EmployeeData: Employee,
        ClothData: Cloth,
        StatesData: States,
        PartyData: Party,
        VendorData:Vendor,
        SalesmanData:Salesman,
        GuaranteerData:Guaranteer,
        ItemData: Item,
        ItemAvgData: ItemAvg,
        RackData: Rack,
        SamplePriceData:SamplePrice,
        SchoolData: School,
        TransportData: Transport,
        LogoData: Logo,
        MaterialData: Material,
        MatInwardData: MatInward,
        MatOutwardData: MatOutward,
        MatStockData: MatStock,
        ClothStockData: clothStock,
        ReadyMStkData: ReadyMadeStk,
        PricePerData: PricePercent,
        JobRateData: JobRate,
        PoNoData: PoNo,
        PurchaseInwardData: PurchaseInward,
        QuotationData: Quotation,
        SaleOrderData: SaleOrder,
        CategoryData: Category,
        CuttingData: SOMcutting,
        ClothIssueData: clothIssue,
        CuttingDatalist: cuttingApi,
        StitchDatalist: StitchApi,
        KajeDatalist: KajeApi,
        PressDatalist: PressingApi,
        StockDatalist: StockApis,
        PackingDatalist: PackApis,
        InvoiceDatalist: InvoiceApi,
        jobworkDatalist: jobworkApi,
        PaymentDatalist: paymentApi,
        TransferData: TransferCloth,
        multipleQuotData: MultipleQuot,
        AllTrackingData: AllTracking,
        NumberingDatalist: numberingApi,
        FusioningDatalist: fusioningApi,
        TrimmingDatalist: TrimApi,
        ReceiptDatalist: receiptApi,
        transportBail: transportBailReducer,
        PrintingData: Printing,
        PatternMatchData: PatternMatching,
        retailerData: retailerApi,
        TeamLeaderDatalist: TeamLeader
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Disable the serializable state invariant middleware
            immutableCheck: false,
        }),
});


